import Repository from "@/plugins/axios";

export default {
  set(data) {
    return Repository.post("/cookie-consent", data);
  },
};
